import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../data/services';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';

const ServicesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Our Services
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Results-focused solutions that drive business growth and efficiency
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {services.map((service) => (
              <div key={service.id} className="bg-white p-8 rounded-lg shadow-sm border border-gray-200">
                <div className="w-16 h-16 bg-gray-100 rounded-lg flex items-center justify-center mb-6">
                  <svg className="w-8 h-8 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  {service.title}
                </h2>
                <p className="text-lg text-gray-600 mb-4">
                  {service.description}
                </p>
                <div className="bg-gray-50 p-4 rounded-lg mb-6">
                  <h3 className="font-semibold text-gray-900 mb-2">Business Outcome</h3>
                  <p className="text-gray-800">{service.outcome}</p>
                </div>
                <div className="mb-6">
                  <h3 className="font-semibold text-gray-900 mb-2">Ideal For</h3>
                  <p className="text-gray-600">{service.targetAudience}</p>
                </div>
                <Link
                  to="/portfolio"
                  className="inline-flex items-center text-gray-900 font-medium hover:text-gray-700"
                >
                  {service.cta}
                </Link>
              </div>
            ))}
          </div>

          <div className="mt-16 text-center bg-white p-8 rounded-lg shadow-sm border border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Need a Custom Solution?
            </h2>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Every business is unique. Let's discuss your specific requirements and 
              create a tailored solution that delivers the results you need.
            </p>
            <Link
              to="/contact"
              className="bg-gray-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors"
            >
              Get Free Consultation
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;
